<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <vs-input class="field-select-input w-full h-full" style="border-radius: 5px;" :value="selectField.field_name" :readonly="readonly" @click="handleClickInput"/>
      <vs-icon icon-pack="feather" icon="icon-home"
               style="padding-left:6px; padding-right:6px; position: absolute; top:auto; right:0; bottom:auto; font-size:24px; border-left: 1px solid #cdcdcd;"
      ></vs-icon>
    </label>

    <popup-search-field v-if="!fieldTypes" v-model="showPopup" :use-types="useTypes" :selectId="selectField.id" @handleClickSelect="handleClickSelect"/>
    <popup-search-field-by-type v-else v-model="showPopup" :field-types="fieldTypes" :project-info="projectInfo" :menu-title="menuTitle"
                                :selectId="selectField.id" @handleClickSelect="handleClickSelect"/>
  </div>
</template>

<script>
import PopupSearchField from '@/popup/PopupSearchField'
import PopupSearchFieldByType from "@/popup/PopupSearchFieldByType.vue";

export default {
  name: 'FieldSelector',
  components: {PopupSearchFieldByType, PopupSearchField },
  props:{
    value:[Number, String],
    fieldName: String,
    readonly: Boolean,
    popupTitle: {
      type: String,
      default: '',
    },
    useTabCodes: Array,
  },
  watch: {
    fieldListInfo: {
      deep: true,
      handler (/*value*/) {}
    },
    menuTitle: {
      deep: true,
      handler (/*value*/) {}
    }
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo

    },
    fieldListInfo () {
      return this.$store.state.project.fieldListInfo
    },
    fieldTypes() {
      let list = []
      if (this.useTabCodes && this.useTabCodes.length > 0) {
        if (this.projectInfo.field_types && this.projectInfo.field_types.length > 0) {
          for (const type of this.projectInfo.field_types) {
            if (this.useTabCodes.indexOf(type.code) >= 0) {
              list.push(type)
            }
          }
        } else {
          return []
        }
      } else {
        list = this.projectInfo.field_types
      }

      return list
    },
    type () {
      // 2023-03-06 추가된 방식.. FieldType 모델과 M:N 관계에 따라서 탭 목록이 변경된다
      if (typeof this.projectInfo.field_types !== 'undefined') {
        const fieldTypes = this.projectInfo.field_types
        if (fieldTypes && fieldTypes.length > 0) {
          return fieldTypes.map((item) => item.name)
        }
      }

      // 기존 방식.. project_type에 따라서 표시되는 탭 목록이 변경된다
      if (typeof this.projectInfo.project_type !== 'undefined') {
        if (this.projectInfo.project_type.indexOf('Premium Ver') >= 0) { //ProjectId = 1
          return ['사업장(직접수행)', '사업장(용역위탁)', '사업장(도급발주)', '시설물']
        } else if (this.projectInfo.project_type.indexOf('Data Base Team') >= 0) { //ProjectId = 2
          return ['사업장(직접수행)']
        } else if (this.projectInfo.project_type.indexOf('파트너입찰(1억이하)') >= 0) { //ProjectId = 3
          return ['사업장(용역위탁)']
        } else if (this.projectInfo.project_type.indexOf('파트너입찰(1억이상)') >= 0) { //ProjectId = 4
          return ['사업장(도급발주)']
        } else if (this.projectInfo.project_type.indexOf('삼성 에스원') >= 0) { //ProjectId = 5
          return ['시설물']
        }
      }
    },
    useTypes () {
      if (typeof this.type === 'string') {
        return [this.type]
      } else {
        return this.type
      }
    },
    selectField () {
      // 만약 초기에 설정된 값이 있으면 표시한다
      if (this.initField.id) {
        return {
          field_name: this.initField.field_name,
          id: this.initField.id,
        }
      }

      const info = this.fieldListInfo

      if (info.data) {
        const list = this.$store.state.project.fieldListInfo.data
        for (const field of list) {
          if (Number(`${field.id}`) === Number(`${this.value}`)) {
            return field
          }
        }
      }
      return {
        field_name: this.fieldName ? this.fieldName : '',
        id: 0
      }
    },
    menuTitle () {
      return this.popupTitle
    }
  },
  data () {
    return {
      showPopup:false,
      initField: {},
    }
  },
  async created () {
    if (this.value) {
      this.initField = await this.$store.dispatch('project/LOAD_FIELD', {postId: this.value})
    }
  },
  methods:{
    handleClickInput () {
      if (!this.readonly) {
        this.showPopup = true
      }
    },

    handleClickSelect (field) {
      // 초기에 전달됐던 데이터는 초기화한다
      this.initField = {};

      this.$emit('input', field.id)
      this.$emit('select', field)
    }
  }
}
</script>

<style >
.field-select-input .vs-input--input.normal {
  padding-right: 40px !important;
}
</style>
